import React, { useEffect, useState } from "react";
import InnerLayout from "../../../components/layouts/inner-layout";
import LoadingSpinner from "../../../components/helper-components/loading-spinner";
import { useDispatch } from "react-redux";
import { useParams } from "react-router-dom";
import { salesDeliveryViewAction } from "../../../redux/actions/sales-action";
import CreateEditViewSalesDelivery from "../../../components/sales-section/delivery-section/create-edit-view-sales-delivery";
const ViewDelivery = () => {
  const { id } = useParams();

  const [orderDetail, setOrderDetail] = useState({});
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  useEffect(() => {
    setLoading(true);
    dispatch(salesDeliveryViewAction(id, onSuccPur, onErrPur));
  }, []);

  const onSuccPur = (data) => {
    setOrderDetail(data?.data?.[0]);
    setLoading(false);
  };

  const onErrPur = (data) => {
    setLoading(false);
  };

  return (
    <>
      {loading ? (
        <LoadingSpinner />
      ) : (
        <InnerLayout backBtn={true} title="View Delivery">
          <CreateEditViewSalesDelivery
            page="view"
            payto={orderDetail?.orderData?.sodtt_pay_to_address}
            shipto={orderDetail?.orderData?.sodtt_ship_to_address}
            data={orderDetail}
            disabled={true}
            orderDetail={orderDetail?.itemData}
            vendorDetails={[orderDetail?.orderData]}
            isNotViewOnly={false}
          />
        </InnerLayout>
      )}
    </>
  );
};
export default ViewDelivery;
